import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import dates from './utils/dates';

export const CellEvent = ({
  event,
  style,
  title,
  className,
  xClassName,
  selected,
  start,
  end,
  isAllDay,
  continuesPrior,
  continuesAfter,
  handleClick,
  Component,
}) => {
  return (
    <div
      style={style}
      id={title}
      className={cn('rbc-event', className, xClassName, {
        'rbc-selected': selected,
        'rbc-event-allday': isAllDay || dates.diff(start, dates.ceil(end, 'day'), 'day') > 1,
        'rbc-event-continues-prior': continuesPrior,
        'rbc-event-continues-after': continuesAfter,
      })}
      onClick={handleClick}
    >
      <div id={title} className="rbc-event-content" title={title}>
        { Component
          ? <Component event={event} title={title} id={title} />
          : title
        }
      </div>
    </div>
  );
};

CellEvent.propTypes = {
  event: PropTypes.object,
  style: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
  xClassName: PropTypes.string,
  selected: PropTypes.bool,
  start: PropTypes.object,
  end: PropTypes.object,
  isAllDay: PropTypes.bool,
  continuesPrior: PropTypes.bool,
  continuesAfter: PropTypes.bool,
  handleClick: PropTypes.func,
  Component: PropTypes.element,
};

export default CellEvent;
